export default __webpack_public_path__ + "static/media/SebastianDelfino.142417cc.svg";